import React from 'react';
import { useState } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import './alert.css'
import { useContext } from 'react';
import SocialContext from '../../context/SocialContext';

export default function Alertjs() {
    const { alertmessage,alertType } = useContext(SocialContext);

    return (
        <>
            <Stack className='stack' sx={{ width: '100%' }} spacing={1}>
                <Alert style={{ 'borderRadius': '0px' }} severity={alertType}>
                    {alertmessage}
                </Alert>
            </Stack>
        </>
    );
}
